import { useSubscriptionInformation } from '../apiHooks/subscriptionInformation';
import type { ProductType } from '../@types/product';

export const useSubscriptionArticlesConfig = (productType: ProductType, articleConfigurationId: string) => {
  const { subscriptionInformation, isSubscriptionInformationLoading } = useSubscriptionInformation(
    productType,
    articleConfigurationId,
  );

  return {
    articles: subscriptionInformation,
    isLoading: isSubscriptionInformationLoading,
  };
};
